export default __webpack_public_path__ + "static/media/amalia-dueak.966482f2.png";